import Vue from 'vue';
export default {
  data() {
    return {
      editInfoTabClass: 'menu-top-items active-tab',
      timeTabClass: 'menu-top-items',
      doctorInsideTabClass: 'menu-top-items',
      moreTabClass: 'menu-top-items',
      noteTabClass: 'menu-top-items',
      addressTabClass: 'menu-top-items',
      missionReportDetailTab: 'mission',
      //mission Info
      missionInfo: [],
      users: [],
      //time
      missionTimes: [],
      stateDataTableItems: [],
      stateDataTableHeader: [],
      //note
      noteText: '',
      noteList: [],
      disabelNoteConfirm: false,
      //address
      addressDataTableHeader: [],
      addressDataTableItems: [],
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      polyline: {
        latlngs: [],
        color: '#49454F',
      },
      mapMarkers: [],
      //admission
      admissionDataTableHeader: [],
      admissionDataTableItems: [],
      otherOrganDataTableHeader: [],
      otherOrganDataTableItems: [],
      info115: [],
      //doctor
      allDoctorOrders: [],
      latLngsPathList: [],
      pathsList: [],
      locationConfiramtionTableHeader: [
        {
          text: 'تاریخ',
          value: 'date',
          align: 'center',
          sortable: false,
        },
        {
          text: 'طول جغرافیایی',
          value: 'longitude',
          align: 'center',
          sortable: false,
        },
        {
          text: 'عرض جغرافیایی',
          value: 'latitude',
          align: 'center',
          sortable: false,
        },
        {
          text: 'کاربر',
          value: 'fullName',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    // show previous path
    loadPath: function (data) {
      if (data.length) {
        this.pathsList = [...data]?.map((eachLocation, index) => {
          if (index > 0) {
            delete eachLocation['angle'];
            const preLat = data[index - 1]?.latitude;
            const preLng = data[index - 1]?.longitude;
            return {
              ...eachLocation,
              bearing: this.bearing(preLat, preLng, eachLocation.latitude, eachLocation.longitude),
            };
          }
          return {
            ...eachLocation,
          };
        });
      }
      const latLngsList = [...this.pathsList].map(({ latitude, longitude }) => {
        return [latitude, longitude];
      });
      this.latLngsPathList = latLngsList;

      this.showAntPath(latLngsList);
    },
    loadMissionReportDetail: function (temp) {
      this.missionInfo = [];
      let rank = '4-سفید';
      let date = '-';
      if (temp.mission) {
        if (temp.mission.rank == 1) {
          rank = '3-سبز';
        } else if (temp.mission.rank == 2) {
          rank = '2-زرد';
        } else if (temp.mission.rank == 3) {
          rank = '1-قرمز';
        }
        if (temp.mission.creationDate) {
          date = Vue.moment(temp.mission.creationDate).format('jYYYY/jM/jD');
        }
      }
      this.missionInfo.push(
        {
          title: 'اولویت',
          content: rank,
          col: 3,
          icon: 'mdi-folder-open mdi-18px',
        },
        {
          title: 'شماره پرونده',
          content: temp.missionIdentifier ? temp.missionIdentifier : '-',
          col: 3,
          icon: 'mdi-folder-open mdi-18px',
        },
        {
          title: 'کد آمبولانس',
          content: temp.phone ? temp.phone.code : '-',
          col: 3,
          icon: 'mdi-ambulance mdi-18px',
        },
        {
          title: 'تاریخ',
          content: date,
          col: 3,
          icon: 'mdi-clock-time-five mdi-18px',
        },
        {
          title: 'تشخیص احتمالی پرستار',
          content: temp.mission && temp.mission.diagnosis ? temp.mission.diagnosis.title : '-',
          col: 3,
          icon: 'mdi-file-document mdi-18px',
        },
        {
          title: 'شکایت اصلی',
          content: temp.mission ? temp.mission.chiefComplaintText : '-',
          col: 9,
          icon: 'mdi-file-document mdi-18px',
        },
        {
          title: 'توضیحات شکایت',
          content:
            temp.mission && temp.mission.chiefComplaintNote ? temp.mission.chiefComplaintNote : '-',
          col: 12,
          icon: 'mdi-file-document mdi-18px',
        },
        {
          title: 'بیمارستان',
          content: temp.hospital ? temp.hospital.title : '-',
          col: 3,
          icon: 'mdi-hospital-building mdi-18px',
        },
        {
          title: 'آدرس',
          content: temp.mission ? temp.mission.address : '-',
          col: 9,
          icon: 'mdi-map-marker mdi-18px',
        },
        {
          title: 'تلفن اصلی',
          content: temp.mission ? temp.mission.callerId : '-',
          col: 3,
          icon: 'mdi-phone mdi-flip-h mdi-18px',
        },
        {
          title: 'تلفن پیگیری',
          content: temp.mission ? temp.mission.otherPhoneNumber : '-',
          col: 3,
          icon: 'mdi-phone mdi-flip-h mdi-18px',
        },
      );
    },
    loadMissionReportUsers: function (temp) {
      this.users = [];
      let user1 = '';
      let user2 = '';
      let user3 = '';
      let user4 = '';
      let user5 = '';
      let user6 = '';
      if (temp.creatorUser) {
        let fName = temp.creatorUser.firstName ? temp.creatorUser.firstName : '-';
        let lName = temp.creatorUser.lastName ? temp.creatorUser.lastName : '-';
        user1 = fName + ' ' + lName;
      }
      if (temp.dispatchUser) {
        let fName = temp.dispatchUser.firstName ? temp.dispatchUser.firstName : '-';
        let lName = temp.dispatchUser.lastName ? temp.dispatchUser.lastName : '-';
        user2 = fName + ' ' + lName;
      }
      if (temp.doctor) {
        let fName = temp.doctor.firstName ? temp.doctor.firstName : '-';
        let lName = temp.doctor.lastName ? temp.doctor.lastName : '-';
        user3 = fName + ' ' + lName;
      }
      if (temp.seniorTechnician) {
        let fName = temp.seniorTechnician.firstName ? temp.seniorTechnician.firstName : '-';
        let lName = temp.seniorTechnician.lastName ? temp.seniorTechnician.lastName : '-';
        user4 = fName + ' ' + lName;
      }
      if (temp.firstTechnician) {
        let fName = temp.firstTechnician.firstName ? temp.firstTechnician.firstName : '-';
        let lName = temp.firstTechnician.lastName ? temp.firstTechnician.lastName : '-';
        user5 = fName + ' ' + lName;
      }
      if (temp.secondTechnician) {
        let fName = temp.secondTechnician.firstName ? temp.secondTechnician.firstName : '-';
        let lName = temp.secondTechnician.lastName ? temp.secondTechnician.lastName : '-';
        user6 = fName + ' ' + lName;
      }
      this.users.push(
        {
          title: 'کارشناس پاسخگو',
          content: user1,
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'کارشناس واحد اعزام',
          content: user2,
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'پزشک 50-10',
          content: user3,
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'تکنسین ارشد',
          content: user4,
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'تکنسین اول',
          content: user5,
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'تکنسین دوم',
          content: user6,
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
      );
    },
    changeTab: function (title) {
      if (title == 'mission') {
        this.editInfoTabClass = 'menu-top-items active-tab';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.missionReportDetailTab = 'mission';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'time') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items active-tab';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.getMissionTimesFunction(this.missionId, this.missionPhoneId);
        this.getAllMissionStateFunction(this.missionId, this.missionPhoneId);
        this.missionReportDetailTab = 'time';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'doctor') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items active-tab';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.missionReportDetailTab = 'doctor';
        this.getAllPatientDoctorDetailFunction(this.missionPhoneId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'moreInfo') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items active-tab';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items';
        this.missionReportDetailTab = 'moreInfo';
        this.getMissionPhoneOtherOrganizationFunction(this.missionId);
        this.getMissionPhoneAdmissionHistoryFunction(this.missionPhoneId);
        this.getMission115Detailfunction(this.missionId);
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'note') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items active-tab';
        this.addressTabClass = 'menu-top-items';
        this.noteText = '';
        this.getAllMissionNoteFunction(this.missionId, this.missionPhoneId);
        this.missionReportDetailTab = 'note';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (title == 'address') {
        this.editInfoTabClass = 'menu-top-items';
        this.timeTabClass = 'menu-top-items';
        this.doctorInsideTabClass = 'menu-top-items';
        this.moreTabClass = 'menu-top-items';
        this.noteTabClass = 'menu-top-items';
        this.addressTabClass = 'menu-top-items active-tab';
        this.getAllMissionAddressLogFunction(this.missionId);
        this.getMissionPhoneLocationsWithStateFunction(this.missionPhoneId);
        this.getMissionConfirmationFunction(this.missionId);
        this.missionReportDetailTab = 'address';
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      }
    },
    addMissionTag: function () {
      let flag = false;
      if (this.missionTagList.length > 0) {
        for (let i = 0; i < this.missionTagList.length; i++) {
          if (this.missionTagList[i].id == this.selectedMissionTag.id) {
            flag = true;
          }
        }
      }
      if (flag == false) {
        this.addToMissionTagByAdmissionFunction(this.missionId, this.selectedMissionTag.id);
      } else {
        this.snackText = 'برچسب قبلا اضافه شده است';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      }
    },
    missionAddedTag: function (data) {
      this.missionTagList.push({
        title: data.tag ? data.tag.title : '-',
        id: data.tag ? data.tag.id : null,
        missionTagId: data.id,
      });
      this.selectedMissionTag = null;
    },
    removeMissionTag: function (id) {
      this.removeTagFromMissionByAdmissionFunction(id);
    },
    missionRemoveTag: function (id) {
      for (let i = 0; i < this.missionTagList.length; i++) {
        if (this.missionTagList[i].missionTagId == id) {
          this.missionTagList.splice(i, 1);
        }
      }
    },
    //time tab
    readyTimeData: function (fenceTimes, data) {
      let fenceMoveFromStationTime = '-';
      let fenceArriveToLocationTime = '-';
      let fenceMoveFromLocationTime = '-';
      let fenceArriveToHospitalTime = '-';
      let fenceFinishTime = '-';
      let fenceArriveToStationTime = '-';
      if (fenceTimes) {
        if (fenceTimes.moveFromStationTime) {
          fenceMoveFromStationTime = Vue.moment(fenceTimes.moveFromStationTime).format('HH:mm:ss');
        }
        if (fenceTimes.arriveToLocationTime) {
          fenceArriveToLocationTime = Vue.moment(fenceTimes.arriveToLocationTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.moveFromLocationTime) {
          fenceMoveFromLocationTime = Vue.moment(fenceTimes.moveFromLocationTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.arriveToHospitalTime) {
          fenceArriveToHospitalTime = Vue.moment(fenceTimes.arriveToHospitalTime).format(
            'HH:mm:ss',
          );
        }
        if (fenceTimes.finishTime) {
          fenceFinishTime = Vue.moment(fenceTimes.finishTime).format('HH:mm:ss');
        }
        if (fenceTimes.arriveToStationTime) {
          fenceArriveToStationTime = Vue.moment(fenceTimes.arriveToStationTime).format('HH:mm:ss');
        }
      }
      this.missionTimes = [];
      let finishTime = '-';
      let arriveToStationTime = '-';
      let patientDeliveryTime = '-';
      let arriveToHospitalTime = '-';
      let moveFromLocationTime = '-';
      let arriveToLocationTime = '-';
      let moveFromStationTime = '-';
      let deliveryTime = '-';
      let seenTime = '-';
      let pickupTime = '-';
      let ringTime = '-';
      let sendTo800Time = '-';
      let dispatchTime = '-';
      if (data.finishTime) {
        finishTime = Vue.moment(data.finishTime).format('HH:mm:ss');
      }
      if (data.arriveToStationTime) {
        arriveToStationTime = Vue.moment(data.arriveToStationTime).format('HH:mm:ss');
      }
      if (data.patientDeliveryTime) {
        patientDeliveryTime = Vue.moment(data.patientDeliveryTime).format('HH:mm:ss');
      }
      if (data.arriveToHospitalTime) {
        arriveToHospitalTime = Vue.moment(data.arriveToHospitalTime).format('HH:mm:ss');
      }
      if (data.moveFromLocationTime) {
        moveFromLocationTime = Vue.moment(data.moveFromLocationTime).format('HH:mm:ss');
      }
      if (data.arriveToLocationTime) {
        arriveToLocationTime = Vue.moment(data.arriveToLocationTime).format('HH:mm:ss');
      }
      if (data.moveFromStationTime) {
        moveFromStationTime = Vue.moment(data.moveFromStationTime).format('HH:mm:ss');
      }
      if (data.deliveryTime) {
        deliveryTime = Vue.moment(data.deliveryTime).format('HH:mm:ss');
      }
      if (data.seenTime) {
        seenTime = Vue.moment(data.seenTime).format('HH:mm:ss');
      }
      if (data.pickupTime) {
        pickupTime = Vue.moment(data.pickupTime).format('HH:mm:ss');
      }
      if (data.ringTime) {
        ringTime = Vue.moment(data.ringTime).format('HH:mm:ss');
      }
      if (data.creationDate) {
        sendTo800Time = Vue.moment(data.creationDate).format('HH:mm:ss');
      }
      if (data.dispatchTime) {
        dispatchTime = Vue.moment(data.dispatchTime).format('HH:mm:ss');
      }
      this.missionTimes.push(
        {
          title: 'زمان تماس',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: ringTime,
          id: 1,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان پاسخ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: pickupTime,
          id: 2,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'ارجاع به 800',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: sendTo800Time,
          id: 3,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'زمان ابلاغ',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: dispatchTime,
          id: 4,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'دریافت ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: deliveryTime,
          id: 5,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'مشاهده ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: seenTime,
          id: 15,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'حرکت از پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromStationTime,
          id: 6,
          size: 3,
          per: false,
          perKey: '',
          secondText: fenceMoveFromStationTime,
        },
        {
          title: 'رسیدن به فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToLocationTime,
          id: 7,
          size: 3,
          per: false,
          perKey: '',
          secondText: fenceArriveToLocationTime,
        },
        {
          title: 'حرکت از فوریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: moveFromLocationTime,
          id: 8,
          size: 3,
          per: false,
          perKey: '',
          secondText: fenceMoveFromLocationTime,
        },
        {
          title: 'رسیدن به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToHospitalTime,
          id: 9,
          size: 3,
          per: false,
          perKey: '',
          secondText: fenceArriveToHospitalTime,
        },
        {
          title: 'تحویل به درمانی',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: patientDeliveryTime,
          id: 10,
          size: 3,
          per: false,
          perKey: '',
          secondText: '',
        },
        {
          title: 'پایان ماموریت',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: finishTime,
          id: 13,
          size: 3,
          per: false,
          perKey: '',
          secondText: fenceFinishTime,
        },
        {
          title: 'رسیدن به پایگاه',
          icon: 'mdi-clock-time-four-outline mdi-18px',
          text: arriveToStationTime,
          id: 12,
          size: 3,
          per: false,
          perKey: '',
          secondText: fenceArriveToStationTime,
        },
      );
    },
    readyStateData: function (data) {
      this.stateDataTableHeader = [
        { text: 'وضعیت', value: 'state', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.stateDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.stateDataTableItems.push({
          state: data[i].state ? data[i].state : '-',
          date: date,
          note: data[i].note ? data[i].note : '-',
          user: user,
        });
      }
    },
    //note tab
    readyNoteData: function (data) {
      this.noteList = [];
      for (let i = 0; i < data.length; i++) {
        let user = '';
        let date = '';
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        if (data[i].noteDate) {
          date = Vue.moment(data[i].noteDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.noteList.push({
          user: user,
          date: date,
          note: data[i].note ? data[i].note : '-',
          id: data[i].id,
        });
      }
    },
    noteHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.addNote();
      }
    },
    addNote: function () {
      this.disabelNoteConfirm = true;
      if (!this.noteText) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      if (!this.noteText.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      this.addNoteToMissionFucntion(this.noteText, this.missionId, this.missionPhoneId);
    },
    //address
    readyAddressLogData: function (data) {
      this.addressDataTableHeader = [
        { text: 'آدرس', value: 'address', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.addressDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.addressDataTableItems.push({
          date: date,
          address: data[i].address ? data[i].address : '-',
          user: user,
        });
      }
    },
    clearSetIntrvals: function () { },
    closeMissionDetailModal: function () {
      this.missionReportDetailTab = 'mission';
      this.missionInfo = [];
      this.users = [];
      this.missionTimes = [];
      this.stateDataTableItems = [];
      this.stateDataTableHeader = [];
      this.noteText = '';
      this.noteList = [];
      this.disabelNoteConfirm = false;
      this.addressDataTableHeader = [];
      this.addressDataTableItems = [];
      this.polyline = {
        latlngs: [],
        color: '#49454F',
      };
      this.$root.$refs.MissionReport.closeDetailModal();
    },
    //other organ
    readyOtherOrganization: function (data) {
      this.otherOrganDataTableHeader = [
        { text: 'عنوان', value: 'title', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
      ];
      this.otherOrganDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        if (data[i].requestDate) {
          date = Vue.moment(data[i].requestDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.otherOrganDataTableItems.push({
          title: data[i].organization ? data[i].organization : '-',
          date: date,
        });
      }
    },
    //115 info
    ready115Info: function (data) {
      this.info115 = [];
      let age = '';
      let gender = '';
      let codes = '';
      if (data.missionCreationDetail) {
        if (data.missionCreationDetail.yearOfAge) {
          age = `${data.missionCreationDetail.yearOfAge} (سال) `;
        }
        if (data.missionCreationDetail.monthOfAge) {
          age += `${data.missionCreationDetail.monthOfAge} (ماه) `;
        }
        if (data.missionCreationDetail?.ageDay) age += `${data.missionCreationDetail.ageDay} (روز)`;
        if (!age) {
          age = '-';
        }
        if (data.missionCreationDetail.gender === 1) {
          gender = 'مرد';
        } else if (data.missionCreationDetail.gender === 2) {
          gender = 'زن';
        } else if (data.missionCreationDetail.gender === 3) {
          gender = 'نامشخص';
        }
      }
      for (let i = 0; i < data.mission115Suggestions.length; i++) {
        codes +=
          data.mission115Suggestions[i].vehicleType.title +
          ' ( ' +
          data.mission115Suggestions[i].count +
          ' ) ';
      }
      this.info115.push(
        {
          title: 'نام',
          content:
            data.missionCreationDetail && data.missionCreationDetail.firstName
              ? data.missionCreationDetail.firstName
              : '-',
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'نام خانوادگی',
          content:
            data.missionCreationDetail && data.missionCreationDetail.lastName
              ? data.missionCreationDetail.lastName
              : '-',
          col: 3,
          icon: 'mdi-account mdi-18px',
        },
        {
          title: 'حدود سن',
          content: age,
          col: 3,
          icon: 'mdi-counter mdi-18px',
        },
        {
          title: 'جنسیت',
          content: gender,
          col: 3,
          icon: 'mdi-human-male-female mdi-18px',
        },
        {
          title: 'نسبت تماس گیرنده',
          content:
            data.missionCreationDetail && data.missionCreationDetail.relation
              ? data.missionCreationDetail.relation
              : '-',
          col: 3,
          icon: 'mdi-account-multiple mdi-18px',
        },
        {
          title: 'کدهای پیشنهادی',
          content: codes,
          col: 6,
          icon: 'mdi-ambulance mdi-18px',
        },
      );
    },
    //admission
    readyAdmissionData: function (data) {
      this.admissionDataTableHeader = [
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          sortable: false,
        },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.admissionDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.admissionDataTableItems.push({
          hospital: data[i].hospital ? data[i].hospital.title : '-',
          date: date,
          user: user,
        });
      }
    },
    //doctor
    readyDoctorData: function (data) {
      this.allDoctorOrders = [];
      for (let i = 0; i < data.length; i++) {
        let patient = '';
        if (data[i].patient) {
          let fName = data[i].patient.firstName ? data[i].patient.firstName : '-';
          let lName = data[i].patient.lastName ? data[i].patient.lastName : '-';
          patient = fName + ' ' + lName;
        }
        this.allDoctorOrders.push({
          patient: patient,
          doctorInfoDataTableHeader: [],
          doctorInfoDataTableItems: [],
          doctorDrugDataTableHeader: [],
          doctorDrugDataTableItems: [],
          doctorOrderDataTableHeader: [],
          doctorOrderDataTableItems: [],
        });
        const mainLength = this.allDoctorOrders.length - 1;
        this.allDoctorOrders[mainLength].doctorInfoDataTableHeader = [
          {
            text: 'تشخیص',
            value: 'dignosis',
            align: 'center',
            sortable: false,
          },
          { text: 'نتیجه', value: 'result', align: 'center', sortable: false },
          { text: 'توضیحات', value: 'note', align: 'center', sortable: false },
          { text: 'پزشک', value: 'doctor', align: 'center', sortable: false },
        ];
        this.allDoctorOrders[mainLength].doctorDrugDataTableHeader = [
          { text: 'نام دارو', value: 'drug', align: 'center', sortable: false },
          { text: 'تعداد', value: 'count', align: 'center', sortable: false },
          {
            text: 'نحوه تجویز',
            value: 'useage',
            align: 'center',
            sortable: false,
          },
          {
            text: 'دستور استفاده',
            value: 'standBy',
            align: 'center',
            sortable: false,
          },
        ];
        this.allDoctorOrders[mainLength].doctorOrderDataTableHeader = [
          {
            text: 'اقدامات درمانی',
            value: 'actions',
            align: 'center',
            sortable: false,
          },
        ];
        let doctor = '';
        if (data[i].doctor) {
          let fName = data[i].doctor.firstName ? data[i].doctor.firstName : '-';
          let lName = data[i].doctor.lastName ? data[i].doctor.lastName : '-';
          doctor = fName + ' ' + lName;
        }
        this.allDoctorOrders[mainLength].doctorInfoDataTableItems.push({
          dignosis: data[i].diagnosis ? data[i].diagnosis : '-',
          result: data[i].result ? data[i].result : '-',
          note: data[i].note ? data[i].note : '-',
          doctor: doctor,
        });
        for (let j = 0; j < data[i].patientDoctorOrders.length; j++) {
          let standBy = 'استفاده شود';
          if (data[i].patientDoctorOrders[j].isStandby) {
            standBy = 'آماده استفاده';
          }
          this.allDoctorOrders[mainLength].doctorDrugDataTableItems.push({
            drug: data[i].patientDoctorOrders[j].drug
              ? data[i].patientDoctorOrders[j].drug.title
              : '-',
            count: data[i].patientDoctorOrders[j].dosage
              ? data[i].patientDoctorOrders[j].dosage
              : '-',
            useage: data[i].patientDoctorOrders[j].drugOrderType
              ? data[i].patientDoctorOrders[j].drugOrderType.title
              : '-',
            standBy: standBy,
          });
        }
        for (let j = 0; j < data[i].patientDoctorActions.length; j++) {
          this.allDoctorOrders[mainLength].doctorOrderDataTableItems.push({
            actions: data[i].patientDoctorActions[j] ? data[i].patientDoctorActions[j].title : '-',
          });
        }
      }
    },
    // showLine: function () {
    //   if (this.missionPhoneId) {
    //     this.getMissionPhoneLocationsFunction(this.missionPhoneId);
    //   }
    // },

    // loadPath: function (data) {
    //   this.polyline.latlngs = [];
    //   if (data.length) {
    //     for (let i = 0; i < data.length; i++) {
    //       let temp = [];
    //       temp.push(data[i].latitude);
    //       temp.push(data[i].longitude);
    //       this.polyline.latlngs.push(temp);
    //     }
    //   }
    // },
    loadMapPositions: function (data) {
      this.mapMarkers = [];
      for (let i = 0; i < data.length; i++) {
        let date = '';
        let time = '';
        if (data[i].date) {
          date = Vue.moment(data[i].date).format('jYYYY/jM/jD');
          time = Vue.moment(data[i].date).format('HH:mm:ss');
        }
        this.mapMarkers.push({
          position: {},
          state: data[i].state,
          date: date,
          time: time,
        });
        this.mapMarkers[i].position.lat = data[i].latitude;
        this.mapMarkers[i].position.lng = data[i].longitude;
      }
    },
  },
};
